(function () {
  'use strict';

  class RegularOrdersListCtrl {
    constructor($scope, $state, $stateParams, $rootScope, CrudApi, UserService, $uibModal, orderStatus) {
      let vm = this;

      // TOD: Its a hack, as we don't have enough time to rework all this
      // This has been done to select the proper tab in Aufgaben
      // Upon pressing browser back button
      // All its doing is setting the parent variable to current tab
      $scope.edit.active = 0;

      // Id of vineyard, use to create new orders
      vm.vineyardId = $stateParams.id;

      // TOD: Its a hack to reset the submenu item, need to work on the is overall
      $rootScope.subMenu = true;

      // Initialize some variables
      vm.itemsPerPage = 20;
      vm.maxSize = 10;
      vm.page = $stateParams.page || 1;
      vm.sorter = $stateParams.sorter || 'deadlineDate';
      vm.dir = $stateParams.dir || 'desc';
      vm.message = $stateParams.message;
      vm.orderStatus = orderStatus;

      vm.items = [];
      vm.total = 0;

      vm.loadData = () => {
          // Api call for fetching the vineyard's map data
          vm.items = CrudApi.query({
              entity: 'orders',
              siteId: $stateParams.id,
              sortBy: vm.sorter,
              sortDir: vm.dir,
              perPage: vm.itemsPerPage,
              page: vm.page
          }, (data, headers, status) => {
              vm.total = headers()['x-total-count'];
              if (status === 204) {
                  vm.message = 'noData';
              }
          });
      };

      // Pagination method
      vm.paginate = () => {
        $state.go($state.current.name, {
          page: vm.page
        });
      };

      // Sorting method
      vm.sort = (sorter) => {
        $state.go($state.current.name, {
          sorter: sorter,
          dir: vm.dir === 'desc' ? 'asc' : 'desc',
          message: null
        });
      };

      // Delete Popup
      vm.delete = (item) => {
        let popup = $uibModal.open({
          controller: 'OrdersDeleteCtrl',
          controllerAs: 'delete',
          templateUrl: 'parcels/edit/orders/delete/views/delete.tpl.html',
          resolve: {
            item: () => {
              return item;
            },
            type: () => {
              return 'regular';
            }
          }
        });
        popup.result.then(() => {
          CrudApi.delete({
            entity: 'orders',
            id: item.id,
            lastModified: item.lastModified
          }, () => {
            // TOD: Its a hack, need to discuss this with Robert. Setting message on parent level
            $scope.edit.message = 'deletingSuccess';
            // Calculate Which page to go after deleting record
            let pageToGo = 1,
                pageToGoCalculate = (vm.total - 1) / vm.itemsPerPage;

            if (pageToGoCalculate % 1 === 0) {
              pageToGo = vm.page - 1;
            } else {
              pageToGo = vm.page;
            }

            // stay on same page if it is not the last one
            if (vm.total / vm.itemsPerPage > vm.page) {
              pageToGo = vm.page;
            }

            vm.page = pageToGo;

            vm.items = CrudApi.query({
              entity: 'orders',
              siteId: $stateParams.id,
              sortBy: vm.sorter,
              sortDir: vm.dir,
              perPage: vm.itemsPerPage,
              page: pageToGo
            }, (data, headers, status) => {
              vm.total = headers()['x-total-count'];

              if (status === 204) {
                vm.message = 'noData';
              }

              // To set the proper page in url
              $state.go($state.current.name, {
                page: vm.page
              });
            });
          }, (response) => {
            if (response.status === 410) {
              $scope.edit.message = 'entityHasChanged';
            } else {
              // TOD: Its a hack, need to discuss this with Robert. Setting message on parent level
              $scope.edit.message = 'deletingError';
            }
          });
        });
      };
    }
  }

  RegularOrdersListCtrl.$inject = ['$scope', '$state', '$stateParams', '$rootScope', 'CrudApi', 'UserService', '$uibModal', 'orderStatus'];
  /**
   * @ngdoc object
   * @name orders.list.controller:RegularOrdersListCtrl
   *
   * @description
   *
   */
  angular
    .module('orders.list')
    .controller('RegularOrdersListCtrl', RegularOrdersListCtrl);
}());
